/*
 * لیست بانک‌های ایران برای تشخیص از روی ۶ رقم اول کارت (BIN).
 *
 * لوگو: به‌جای فایل‌های محلی، از پکیج آماده‌ی «iranianbanklogos» استفاده می‌شه
 * (یه اسپرایت CSS با لوگوهای واقعی بانک‌های ایران، رایگان و بدون نیاز به میزبانی فایل):
 *
 *   npm install iranianbanklogos
 *
 * و توی نقطه‌ی ورود اپ (یا همین کامپوننت) این خط اضافه بشه:
 *
 *   import "iranianbanklogos/dist/ibl.css";
 *
 * هر بانک که توی این پکیج لوگو داشته باشه، فیلد `logo` رو پر داره (کد اسپرایت).
 * اگه `logo` نال باشه (چند مورد پیدا نشد)، همون دایره‌ی رنگی با حرف اول اسم
 * بانک به‌عنوان جایگزین نشون داده می‌شه؛ رنگ‌ها فقط برای همین حالتن.
 */

export const BANKS = [
  {
    id: "melli",
    name: "بانک ملی ایران",
    short: "ملی",
    color: "#1d4f91",
    logo: "bmi",
    bins: ["603799"],
  },
  {
    id: "sepah",
    name: "بانک سپه",
    short: "سپه",
    color: "#e8731a",
    logo: "sepah",
    bins: ["589210"],
  },
  {
    id: "saderat",
    name: "بانک صادرات ایران",
    short: "صادرات",
    color: "#1b4f9c",
    logo: "bsi",
    bins: ["603769"],
  },
  {
    id: "keshavarzi",
    name: "بانک کشاورزی",
    short: "کشاورزی",
    color: "#2e8b3d",
    logo: "bki",
    bins: ["603770", "639217"],
  },
  {
    id: "maskan",
    name: "بانک مسکن",
    short: "مسکن",
    color: "#e67e22",
    logo: "maskan",
    bins: ["628023"],
  },
  {
    id: "mellat",
    name: "بانک ملت",
    short: "ملت",
    color: "#d0232a",
    logo: "mellat",
    bins: ["610433", "991975"],
  },
  {
    id: "tejarat",
    name: "بانک تجارت",
    short: "تجارت",
    color: "#1f3d8c",
    logo: "tejarat",
    bins: ["627353", "585983"],
  },
  {
    id: "refah",
    name: "بانک رفاه کارگران",
    short: "رفاه",
    color: "#0b6fa4",
    logo: "rb",
    bins: ["589463"],
  },
  {
    id: "postbank",
    name: "پست بانک ایران",
    short: "پست",
    color: "#00843d",
    logo: "post",
    bins: ["627760"],
  },
  {
    id: "tosee-saderat",
    name: "بانک توسعه صادرات ایران",
    short: "توسعه صادرات",
    color: "#0f4c81",
    logo: "edbi",
    bins: ["627648", "207177"],
  },
  {
    id: "tosee-taavon",
    name: "بانک توسعه تعاون",
    short: "توسعه تعاون",
    color: "#1d8a4b",
    logo: "tt",
    bins: ["502908"],
  },
  {
    id: "sanat-madan",
    name: "بانک صنعت و معدن",
    short: "صنعت و معدن",
    color: "#0b5394",
    logo: "bim",
    bins: ["627961"],
  },
  {
    id: "markazi",
    name: "بانک مرکزی",
    short: "مرکزی",
    color: "#3d3d4e",
    logo: null,
    bins: ["636795"],
  },
  {
    id: "parsian",
    name: "بانک پارسیان",
    short: "پارسیان",
    color: "#b3132a",
    logo: "parsian",
    bins: ["622106", "639194", "627884"],
  },
  {
    id: "pasargad",
    name: "بانک پاسارگاد",
    short: "پاسارگاد",
    color: "#c8971d",
    logo: "bpi",
    bins: ["502229", "639347"],
  },
  {
    id: "saman",
    name: "بانک سامان",
    short: "سامان",
    color: "#1d6fb8",
    logo: "sb",
    bins: ["621986"],
  },
  {
    id: "eghtesad-novin",
    name: "بانک اقتصاد نوین",
    short: "اقتصاد نوین",
    color: "#6a2c91",
    logo: "en",
    bins: ["627412"],
  },
  {
    id: "karafarin",
    name: "بانک کارآفرین",
    short: "کارآفرین",
    color: "#2f8f5b",
    logo: "kar",
    bins: ["627488", "502910"],
  },
  {
    id: "sina",
    name: "بانک سینا",
    short: "سینا",
    color: "#0d7a4c",
    logo: "sina",
    bins: ["639346"],
  },
  {
    id: "sarmayeh",
    name: "بانک سرمایه",
    short: "سرمایه",
    color: "#1f4e79",
    logo: "sarmayeh",
    bins: ["639607"],
  },
  {
    id: "shahr",
    name: "بانک شهر",
    short: "شهر",
    color: "#d71920",
    logo: "shahr",
    bins: ["502806", "504706"],
  },
  {
    id: "day",
    name: "بانک دی",
    short: "دی",
    color: "#0f8ac0",
    logo: "day",
    bins: ["502938"],
  },
  {
    id: "ayandeh",
    name: "بانک آینده",
    short: "آینده",
    color: "#7a2b83",
    logo: "ba",
    bins: ["636214"],
  },
  {
    id: "gardeshgari",
    name: "بانک گردشگری",
    short: "گردشگری",
    color: "#1d7fb5",
    logo: "tourism",
    bins: ["505416"],
  },
  {
    id: "iran-zamin",
    name: "بانک ایران‌زمین",
    short: "ایران‌زمین",
    color: "#1a5e8c",
    logo: "iz",
    bins: ["505785"],
  },
  {
    id: "khavarmianeh",
    name: "بانک خاورمیانه",
    short: "خاورمیانه",
    color: "#0b7285",
    logo: "me",
    bins: ["585947"],
  },
  {
    id: "ansar",
    name: "بانک انصار",
    short: "انصار",
    color: "#c0392b",
    logo: "ansar",
    bins: ["627381"],
  },
  {
    id: "hekmat",
    name: "بانک حکمت ایرانیان",
    short: "حکمت",
    color: "#7d5a2c",
    logo: "hi",
    bins: ["636949"],
  },
  {
    id: "ghavamin",
    name: "بانک قوامین",
    short: "قوامین",
    color: "#256d85",
    logo: "ghbi",
    bins: ["639599"],
  },
  {
    id: "mehr-eghtesad",
    name: "بانک مهر اقتصاد",
    short: "مهر اقتصاد",
    color: "#d35400",
    logo: null,
    bins: ["639370", "606737"],
  },
  {
    id: "mehr-iran",
    name: "بانک قرض‌الحسنه مهر ایران",
    short: "مهر ایران",
    color: "#0e8f6e",
    logo: "miran",
    bins: ["606373"],
  },
  {
    id: "resalat",
    name: "بانک قرض‌الحسنه رسالت",
    short: "رسالت",
    color: "#2b8a3e",
    logo: "resalat",
    bins: ["504172"],
  },
  {
    id: "tosee",
    name: "مؤسسه اعتباری توسعه",
    short: "توسعه",
    color: "#495057",
    logo: null,
    bins: ["628157"],
  },
  {
    id: "kosar",
    name: "مؤسسه اعتباری کوثر",
    short: "کوثر",
    color: "#7b1fa2",
    logo: null,
    bins: ["505801"],
  },
  {
    id: "melal",
    name: "مؤسسه اعتباری ملل",
    short: "ملل",
    color: "#b02a37",
    logo: "melal",
    bins: ["606256"],
  },
];

// ایندکس BIN → بانک، یک بار موقع لود ماژول ساخته می‌شه
const BIN_INDEX = BANKS.reduce((acc, bank) => {
  bank.bins.forEach((bin) => {
    acc[bin] = bank;
  });
  return acc;
}, {});

// از ارقام (انگلیسی) شماره کارت، بانک رو برمی‌گردونه؛ اگه پیدا نشد null
export const detectBank = (digits = "") =>
  digits.length >= 6 ? BIN_INDEX[digits.slice(0, 6)] || null : null;
